import { useEffect, useState } from "react";
import { PreCandidateService } from "../../../../services/PreCandidate";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export function InactiveManagers() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [inactiveManagers, setInactiveManagers] = useState([]);

  useEffect(() => {
    PreCandidateService.GetInactiveManagerList().then((data) => setInactiveManagers(data));
  }, []);

  return (
    <fieldset>
      {" "}
      <legend>{t("Others Managers")}</legend>
      <select
        className="form-select"
        name="managerId"
        onChange={onChange}
        value={searchObject.managerId || ""}
      >
        <option value=""></option>
        {inactiveManagers.map((managers) => (
          <option key={managers.id} value={managers.id}>
            {managers.nickname}
          </option>
        ))}
      </select>
    </fieldset>
  );
}
